<template>
  <div>
    <div class="statisticBox" :model="statistic">
      <div class="statisticHeader">
        <div class="floatitem">
          <span class="iconfont icon-dikuai statistic-icon"></span>
        </div>
        <div class="floatitem">
          <div>count</div>
          <div class="statisticHeaderNum">{{ statistic["all"].count }}</div>
        </div>
        <div class="floatitem">
          <div>area</div>
          <div class="statisticHeaderNum statisticArea">
            {{ statistic["all"].area }}
          </div>
        </div>
      </div>

      <div>
        <div class="floatitem">boundary</div>
        <div class="floatitem">{{ statistic["boundary"].count }}</div>
        <div class="floatitem statisticArea">
          {{ statistic["boundary"].area }}
        </div>
      </div>

      <div>
        <div class="floatitem">obstacle</div>
        <div class="floatitem">{{ statistic["obstacle"].count }}</div>
        <div class="floatitem statisticArea">
          {{ statistic["obstacle"].area }}
        </div>
      </div>

      <div>
        <div class="floatitem">nospray</div>
        <div class="floatitem">{{ statistic["nospray"].count }}</div>
        <div class="floatitem statisticArea">
          {{ statistic["nospray"].area }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../assets/icon/ali icon/iconfont";
export default {
  name: "fieldStatistic",
  // 父组件传值
  props: {
    statistic: {
      default: {
        all: {
          count: 3,
          area: 0.15,
        },
        boundary: {
          count: 3,
          area: 0.15,
        },
        obstacle: {
          count: 3,
          area: 0.15,
        },
        nospray: {
          count: 3,
          area: 0.45,
        },
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="">
.statisticBox {
  height: 140px;
  width: 300px;
  position: absolute;
  left: 260px;
  top: 80px;
  z-index: 1;
  background-color: aliceblue;
  border-radius: 10px;
  padding: 15px;
}
.statistic-icon {
  font-size: 40px;
  color: #f59a23;
  left: 20px;
}
.statisticHeader {
  height: 60px;
}
.statisticHeaderNum {
  margin: 10px 0px 0px 0px;
  font-size: 23px;
  color: #000000;
}
.floatitem {
  font-size: smaller;
  width: 80px;
  float: left;
  margin: 5px;
  color: #aaaaaa;
  text-align: center;
}
.statisticArea {
  width: 110px;
}
</style>


// WEBPACK FOOTER //
// src/components/fieldStatistic.vue